import React, { useEffect, useState } from "react";
import axios from "axios";
import ENVIRONMENT from "../../../../environments";
import { Row, Modal, Button, Tabs, Col, message, Tooltip } from "antd";
import EntityItem from "../EntityCard/EntityCard";
import LibraryGrid from "../LibraryGrid/LibraryGrid";
import { QuestionCircleOutlined } from "@ant-design/icons";
import DottedLoader from "../../DottedLoader/DottedLoader";
import "./SwapSpace.scss";
import FileConstants from "../../../../FileConstants";

const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;

const { TabPane } = Tabs;

const SwapSpace = (props) => {
    const [columnCount, setColumnCount] = useState(4);
    const [rowCount, setRowCount] = useState(1);
    const maxColumnWidth = 280;
    const rowSize = 460;
    const { swap_space_modal, toggleSwapSpaceModal, room_id, handleSwapSpace, collection_id, scene_id, room_parent, setLoading } =
        props;
    const [variantsData, setVariantsData] = useState([]);
    const [tabActiveKey, setTabActiveKey] = useState("variants");
    const [selected, setSelected] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [selectedElementDetials, setSelectedElementDetials] = useState({});
    const tabs = [
        {
            key: "variants",
            title: "Variants",
            data: variantsData,
        },
    ];

    useEffect(() => {
        setRowCount(Math.ceil(variantsData.length / columnCount));
    }, [variantsData]);

    const cellRenderer = ({ columnIndex, key, rowIndex, style }) => {
        const itemIndex = rowIndex * columnCount + columnIndex;
        const ele = variantsData[itemIndex] && variantsData[itemIndex];
        if (!ele) {
            return null;
        }

        return (
            <div key={key} style={style}>
                <EntityItem
                    key={key}
                    ele={ele}
                    selectable={true}
                    selected={selected}
                    setSelected={setSelected}
                    singleSelect={true}
                    entityType="room"
                    setSelectedElementDetials={setSelectedElementDetials}
                    checked= {ele.room_id == room_id}
                />
            </div>
        );
    };

    const getRoomPayload = (initial, type, sequence_id) => {
        const payload = {
            required_fields: [
                "room_id",
                "room_name",
                "brand_id",
                "category",
                "dimensions",
                "customer_username",
                "model_status",
                "thumbnail",
                "last_modified_stamp",
                "variant_of",
                "is_store_item",
                "company_id",
                "style",
                "platform",
                "tags",
                "price",
            ],
        };

        let filter_string = "";
        let parent_filter = ""
        if (room_parent) {
            parent_filter = `variant_of__exact='${room_parent}'||room_id__exact='${room_parent}'||`
        }
        filter_string = `(${parent_filter}variant_of__exact='${room_id}'||room_id__exact='${room_id}'&&model_status__in=[5])`;
        payload["filter_string"] = filter_string;
        payload["order_by"] = "last_modified_stamp desc";
        return payload;
    };

    const fetchRoomData = async () => {
        setDataLoading(true);
        const payload = getRoomPayload();
        const data = [];
        await axios.post(ENVIRONMENT.LIST_ROOMS, payload).then((res) => {
            if (res.data) {
                setVariantsData(res.data);
            }
            setDataLoading(false);
        });
        return data;
    };

    const handleCancelSwapSpaceModal = () => {
        toggleSwapSpaceModal(false);
        setSelected([]);
    };

    const handleTabChange = (key) => {
        setTabActiveKey(key);
    };

    const handleSubmit = async () => {
        const roomId = selectedElementDetials.room_id;
        setLoading(true);
        const CollectionPayload = {
            room_id: roomId,
            collection_id: collection_id,
            username: CUSTOMER_USERNAME,
        };

        const ScenePayload = {
            room_id: roomId,
            scene_id: scene_id,
        };

        handleCancelSwapSpaceModal();

        await axios.post(ENVIRONMENT.UPDATE_COLLECTION, CollectionPayload)
            .then((res) => {
            })
            .catch(() => {
                setLoading(false);
                message.error("Failed to swap space");
                return;
            });

        await axios.post(ENVIRONMENT.UPDATE_SCENE, ScenePayload)
            .then((response) => {
            })
            .catch((error) => {
                setLoading(false);
                message.error("Failed to swap space");
                return;
            });

        handleSwapSpace(selectedElementDetials, () => {
            setLoading(false);
            message.success("Space Swapped Successfully");
        });
    };

    useEffect(() => {
        if (room_id) {
            fetchRoomData();
        }
    }, [room_id]);

    return (
        <Modal
            destroyOnClose={true}
            closable={true}
            onCancel={handleCancelSwapSpaceModal}
            className="swap-modal"
            bodyStyle={{ padding: 0 }}
            footer={null}
            visible={swap_space_modal}
        >
            <Row className="header-container">
                <div className="swap-heading-tag">
                    <span className="manrope f-14">Swap Space</span>
                </div>
            </Row>
            <Row className="justify-space-between swap-container">
                <Col span={16} className="justify-in-start">
                    <span className="manrope f-20 w-600">Choose a space below to replace the current space</span>
                </Col>
            </Row>
            <div className="swap-container">
                <Tabs
                    onChange={(key) => handleTabChange(key)}
                    className="product-tab library"
                    tabBarGutter={16}
                    size="large"
                    activeKey={tabActiveKey}
                >
                    {tabs?.map((tab) => {
                        return (
                            <TabPane
                                tab={tab.title + ` (${tab.data.length})`}
                                key={tab.key}
                                style={{ padding: "0px 10px" }}
                            >
                                <span className="f-14 4-400 swap-info-text">
                                    <Tooltip title="You can only swap the space in your scene with a variant of that space so that your product layout isn’t affected.">
                                        <QuestionCircleOutlined style={{marginRight: "4px"}} />
                                    </Tooltip>
                                        Why am I only seeing these spaces?
                                </span>
                                {dataLoading ? (
                                    <div className="modal-tab">
                                        <DottedLoader />
                                    </div>
                                ) : variantsData.length == 0 ? (
                                    <div
                                        className="empty-section modal-tab justify-in-center"
                                    >
                                        <div className="justify-in-center" style={{flexDirection:"column"}}>
                                            <img
                                                id="empty-section-image"
                                                style={{ width: "50%" }}
                                                src="../../../../img/Collections.svg"
                                            />
                                            <p className="empty-section-text manrope f-14 black-55">
                                                Nothing to show
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="product-tab library">
                                        <LibraryGrid
                                            setColumnCount={setColumnCount}
                                            setRowCount={setRowCount}
                                            maxColumnWidth={maxColumnWidth}
                                            data={variantsData}
                                            cellRenderer={cellRenderer}
                                            columnCount={columnCount}
                                            getColumnWidth={() => { }}
                                            rowCount={rowCount}
                                            getEstimatedRowSize={rowSize}
                                            handleColumnWidthChange={() => { }}
                                            height={280}
                                            isDisplayOnly={true}
                                        />
                                    </div>
                                )}
                            </TabPane>
                        );
                    })}
                </Tabs>
            </div>
            <Row className="swap-modal-footer justify-in-end" onClick={() => { }}>
                <Button
                    style={{ marginRight: 10 }}
                    className="outline-red-btn square font-12 manrope"
                    onClick={handleCancelSwapSpaceModal}
                >
                    Cancel
                </Button>
                <Button
                    className="modal-okay square font-14"
                    onClick={handleSubmit}
                    disabled={selected.length === 0}
                >
                    Continue
                </Button>
            </Row>
        </Modal>
    );
};

export default SwapSpace;
